import React from 'react'
import { SquarePen } from 'lucide-react'
import { tokens } from '../../../assets/tokens'

const icon = props => <SquarePen size={20} color={tokens.color.text.disabled} {...props} />

export default icon
